import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {fetchAllPages} from '../_utils/http-params';
import {
    NewSegment,
    NewSegmentRule,
    NewSegmentRuleGroup,
    Segment,
    SegmentRule,
    SegmentRulesGroup
} from '../_types/segments';
import {User} from '../_types/user';

@Injectable({
    providedIn: 'root'
})
export class SegmentsService {
    private api: string = `${environment.apiUrl}/segments`;
    private apiRule: string = `${environment.apiUrl}/segment-rules`;
    private apiRuleGroups: string = `${environment.apiUrl}/segment-rules-groups`;

    constructor(private http: HttpClient) {
    }

    getSegments(communityId?: number): Observable<Segment[]> {
        let params: HttpParams = new HttpParams();
        if (typeof communityId === 'number') {
            params = params.set('community_id', communityId.toString());
        }
        return fetchAllPages<Segment>(this.http, `${this.api}/`, 1000, params);
    }

    getSegmentUsers(segmentId: number): Observable<User[]> {
        return fetchAllPages<User>(this.http, `${this.api}/${segmentId}/users/`, 1000);
    }

    newSegment(data: NewSegment): Observable<Segment> {
        return this.http.post<Segment>(`${this.api}/`, data);
    }

    updateSegment(segmentId: number, data: NewSegment): Observable<Segment> {
        return this.http.patch<Segment>(`${this.api}/${segmentId}/`, data);
    }

    deleteSegment(segmentId: number): Observable<void> {
        return this.http.delete<void>(`${this.api}/${segmentId}/`);
    }

    getSegmentRules(community_id?: number): Observable<SegmentRule[]> {
        let params: HttpParams = new HttpParams();
        if (community_id) {
            params = params.set('community_id', community_id);
        }
        return fetchAllPages<SegmentRule>(this.http, `${this.apiRule}/`, 1000, params);
    }

    newSegmentRule(data: NewSegmentRule): Observable<SegmentRule> {
        return this.http.post<SegmentRule>(`${this.apiRule}/`, data);
    }

    updateSegmentRule(segmentRuleId: number, data: NewSegmentRule): Observable<SegmentRule> {
        return this.http.patch<SegmentRule>(`${this.apiRule}/${segmentRuleId}/`, data);
    }

    deleteSegmentRule(segmentRuleId: number): Observable<void> {
        return this.http.delete<void>(`${this.apiRule}/${segmentRuleId}/`);
    }

    getSegmentRuleGroups(community_id?: number): Observable<SegmentRulesGroup[]> {
        let params: HttpParams = new HttpParams();
        if (community_id) {
            params = params.set('community_id', community_id);
        }
        return fetchAllPages<SegmentRulesGroup>(this.http, `${this.apiRuleGroups}/`, 1000, params);
    }

    newSegmentRuleGroup(data: NewSegmentRuleGroup): Observable<SegmentRulesGroup> {
        return this.http.post<SegmentRulesGroup>(`${this.apiRuleGroups}/`, data);
    }

    updateSegmentRuleGroup(segmentRuleGroupId: number, data: NewSegmentRuleGroup): Observable<SegmentRulesGroup> {
        return this.http.patch<SegmentRulesGroup>(`${this.apiRuleGroups}/${segmentRuleGroupId}/`, data);
    }

    deleteSegmentRuleGroup(segmentRuleGroupId: number): Observable<void> {
        return this.http.delete<void>(`${this.apiRuleGroups}/${segmentRuleGroupId}/`);
    }


    getSegmentsUsers(segmentId: number): Observable<User[]> {
        return fetchAllPages<User>(this.http, `${environment.apiUrl}/segment-users/${segmentId}/`, 1000);
    }

    addSegmentUsers(segmentId: number, users: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/segment-users/${segmentId}/`, {users: [users]});
    }

    deleteSegmentUsers(segmentId: number, users: any): Observable<void> {
        let params: HttpParams = new HttpParams();
        params = params.set('users', users.join(','));
        return this.http.delete<void>(`${environment.apiUrl}/segment-users/${segmentId}/`, {params});
    }

    addSegmentUsersViaCSv(segmentId: number, file: any) {
        const headerAttachmentNameValue: string = 'attachment; filename="csv-user-add"';
        const headers = {
            'Content-Disposition': headerAttachmentNameValue,
        };
        const fd: FormData = new FormData();
        if (file) {
            fd.append('csv_file', file);
        }
        return this.http.post<any>(`${environment.apiUrl}/segment-import-csv/${segmentId}/`, fd, {
            headers
        });
    }

    addUsersToSubgroupByCSV(id: number, file: any) {
        const headerAttachmentNameValue: string = 'attachment; filename="csv-user-add"';
        const headers = {
            'Content-Disposition': headerAttachmentNameValue,
        };
        const fd: FormData = new FormData();
        if (file) {
            fd.append('csv_file', file);
        }
        return this.http.post<any>(`${environment.apiUrl}/subgroup-import-csv/${id}/`, fd, {
            headers
        });
    }
}
